import './App.css';
import JavascriptCalculator from './JavascriptCalculator';

function App() {
  return (
    <div className="App">
      <JavascriptCalculator />
    </div>
  );
}

export default App;
